import FJViewConstant from "../../constant/FJViewConstant";
import FJUtil from "../../util/FJUtil";
import FJCanvasStore from "../../store/FJCanvasStore";

let FJFilterAction = (function () {
  return {

    /**
     * @description 改变滤镜强度
     * @param data
     */
    intensityChangeAction: function (data) {
      return (dispatch) => {
        let {type, value} = data;
        if (type) {
          FJUtil.toggleScope(type);
        }
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_FILTER_DATA, {intensity: value / 100}, {type});
        dispatch(this.setIntensityAction(value));
      };
    },

    /**
     * @description 更新滤镜强度reducer
     * @param intensity
     * @return {{intensity, type: string}}
     */
    setIntensityAction: function (intensity) {
      return {
        type: FJViewConstant.SET_FILTER_INTENSITY,
        intensity,
      }
    },

    /**
     * @description 滤镜切换
     * @param type
     */
    filterChangeAction: function (type) {
      return (dispatch) => {
        let intensity = FJCanvasStore.executeSync(FJCanvasStore.command.SET_FILTER_DATA, {filterType: type});
        dispatch(this.setFilterTypeAction(type));
        dispatch(this.setIntensityAction(intensity * 100));
        dispatch(this.updateAdjustDisabledAction());
      };
    },

    /**
     * @description 更新滤镜类型
     * @param filterType
     */
    setFilterTypeAction: function (filterType) {
      return {
        type: FJViewConstant.SET_FILTER_TYPE,
        filterType,
      }
    },

    /**
     * @description 滤镜激活状态更改
     * @param active
     * @return {function(*): void}
     */
    filterActiveChangeAction: function (active) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_FILTER_DATA, {active});
        dispatch(this.setFilterActiveAction(active));
        dispatch(this.updateAdjustDisabledAction());
      };
    },

    /**
     * @description 更新滤镜激活状态
     * @param active
     * @return {{active, type: string}}
     */
    setFilterActiveAction: function (active) {
      return {
        type: FJViewConstant.SET_FILTER_ACTIVE,
        active,
      }
    },

    /**
     * @description adjust滤镜激活调整
     * @param active
     * @return {function(*): void}
     */
    adjustActiveChangeAction: function (active) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_ADJUST_DATA, {active});
        dispatch(this.setAdjustActiveAction(active));
      };
    },

    /**
     * @description 应用滤镜到所有视频、图片
     */
    applyToAllForFilterAction: function () {
      return (dispatch, getState) => {
        let {filterType, intensity, filterActive} = getState().filter;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_FILTER_DATA, {
          apply: true,
          filter: {
            type: filterType,
            intensity: intensity / 100,
            active: filterActive,
          }
        });
      };
    },

    /**
     * @description 应用adjust滤镜到所有视频、图片
     */
    applyToAllForAdjustAction: function () {
      return (dispatch, getState) => {
        let {exposure, brightness, temperature, tint, saturation, contrast, highlights, shadows, vignette, adjustActive} = getState().filter;
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_ADJUST_DATA, {
          apply: true,
          adjust: {
            active: adjustActive,
            exposure: exposure / 100,
            brightness: brightness / 100,
            temperature: temperature / 100,
            tint: tint / 100,
            saturation: saturation / 100,
            contrast: contrast / 100,
            highlights: highlights / 100,
            shadows: shadows / 100,
            vignette: vignette / 100,
          }
        });
      };
    },

    /**
     * @description 重置所有adjust
     */
    resetAdjustAction: function () {
      return (dispatch) => {
        let data = FJCanvasStore.executeSync(FJCanvasStore.command.SET_ADJUST_DATA, {reset: true});
        dispatch(this.setAdjustDataAction(data));
      };
    },

    /**
     * @description 更改adjust滤镜
     * @param itemKey
     * @param data
     */
    adjustDataChangeAction: function (itemKey, data) {
      return (dispatch) => {
        let {type, value} = data;
        if (type) {
          FJUtil.toggleScope(type);
        }
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_ADJUST_DATA, {[itemKey]: value / 100}, {type});
        dispatch(this.setAdjustDataAction({[itemKey]: value}));
      };
    },

    /**
     * @description 更新adjust是否激活
     * @param active
     * @return {{active, type: string}}
     */
    setAdjustActiveAction: function (active) {
      return {
        type: FJViewConstant.SET_ADJUST_ACTIVE,
        active,
      }
    },

    /**
     * @description 更新reducer中的adjust数据
     * @param adjustData
     * @return {{type: string, adjustData}}
     */
    setAdjustDataAction: function (adjustData) {
      return {
        type: FJViewConstant.SET_ADJUST_DATA,
        adjustData,
      }
    },

    /**
     * @description 更新adjust的禁用数据
     */
    updateAdjustDisabledAction: function () {
      return (dispatch, getState) => {
        let {filterType, filterActive, disableAdjusts} = getState().filter;
        let length = disableAdjusts.length;
        if (filterActive && filterType === 'black & white 4') {
          if (length === 0) {
            dispatch({
              type: FJViewConstant.SET_ADJUST_DISABLED,
              disableAdjusts: ['saturation'],
            });
          }
        } else if (length !== 0) {
          dispatch({
            type: FJViewConstant.SET_ADJUST_DISABLED,
            disableAdjusts: [],
          });
        }
      };
    }
  }
})();

export default FJFilterAction;